import React from 'react'
import { Link } from 'react-router-dom'

export interface PreferencesProps {}

export const Preferences: React.FC<PreferencesProps> = () => {
  return (
    <main className='my-c-dashboard'>
      <h1 className='my-u-mb--8 my-u-mt--0' id='maincontent' tabIndex={-1}>Preferences</h1>
      <Link to='/'>Dashboard</Link>
    </main>
  )
}
